/**
 * PublicNavbar — barra superior minimalista para páginas públicas do marketplace.
 * Exibe logo + link de volta ao marketplace + botão de login (ou avatar se já autenticado).
 */
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
  AppBar, Avatar, Box, Button, Chip, Container, IconButton,
  Menu, MenuItem, Stack, Toolbar, Tooltip, Typography,
} from '@mui/material';
import ExtensionIcon from '@mui/icons-material/Extension';
import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

export default function PublicNavbar() {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{ bgcolor: 'background.paper', borderBottom: '1px solid', borderColor: 'divider' }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ gap: 2, minHeight: 56 }}>
          {/* Logo */}
          <RouterLink to="/" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center', gap: 8 }}>
            <ExtensionIcon color="primary" sx={{ fontSize: 22 }} />
            <Typography variant="subtitle1" fontWeight={800} color="text.primary" letterSpacing={-0.5}>
              Pipenodes
            </Typography>
          </RouterLink>

          <Chip
            label="Marketplace"
            size="small"
            variant="outlined"
            component={RouterLink}
            to="/marketplace"
            clickable
            sx={{ cursor: 'pointer', fontSize: 12 }}
          />

          <Box sx={{ flexGrow: 1 }} />

          {isAuthenticated ? (
            <>
              <Button
                variant="outlined"
                size="small"
                onClick={() => navigate('/dashboard')}
                sx={{ mr: 1 }}
              >
                Dashboard
              </Button>
              <Tooltip title={user?.email ?? 'Conta'}>
                <IconButton onClick={(e) => setAnchor(e.currentTarget)} size="small">
                  <Avatar sx={{ width: 32, height: 32, fontSize: 14, bgcolor: 'primary.main' }}>
                    {user?.email?.[0]?.toUpperCase() ?? 'U'}
                  </Avatar>
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={anchor}
                open={Boolean(anchor)}
                onClose={() => setAnchor(null)}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <MenuItem onClick={() => { setAnchor(null); navigate('/settings'); }}>
                  Configurações
                </MenuItem>
                <MenuItem onClick={() => { setAnchor(null); logout(); }}>
                  Sair
                </MenuItem>
              </Menu>
            </>
          ) : (
            <Stack direction="row" spacing={1}>
              <Button
                variant="outlined"
                size="small"
                component={RouterLink}
                to="/auth/login"
              >
                Entrar
              </Button>
              <Button
                variant="contained"
                size="small"
                component={RouterLink}
                to="/auth/register"
              >
                Criar conta
              </Button>
            </Stack>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}
